import { render, staticRenderFns } from "./TheSnapshotFileDiff.vue?vue&type=template&id=525a571b&"
import script from "./TheSnapshotFileDiff.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotFileDiff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports